import { render } from "./CVViewer.vue?vue&type=template&id=05b9fd8d&scoped=true&lang=true"
import script from "./CVViewer.vue?vue&type=script&lang=js"
export * from "./CVViewer.vue?vue&type=script&lang=js"

import "./CVViewer.vue?vue&type=style&index=0&id=05b9fd8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b9fd8d"]])

export default __exports__